<div dropdown class="dropdown dropdown-language" aria-haspopup="true" [dropup]="isDropup">
    <div dropdownToggle
         class="topbar-item"
         data-toggle="dropdown"
         data-offset="10px,0px" aria-expanded="false">
        <div [class]="customStyle">
            <i class="fa fa-font"></i>
        </div>
    </div>
    <div *dropdownMenu class="dropdown-menu p-0 m-0 dropdown-menu-anim-up dropdown-menu-sm dropdown-menu-right"
         [attr.aria-label]="l('Languages')">
            <ul class="navi navi-hover py-4">
                <li class="navi-item">
                    <a class="navi-link" (click)="htmlFontSizeSet(14)">
                        <span class="navi-text">
                            Small
                        </span>
                    </a>
                </li>
                <li class="navi-item">
                    <a class="navi-link"  (click)="htmlFontSizeSet(18)">
                        <span class="navi-text">
                            Medium
                        </span>
                    </a>
                </li>
                <li class="navi-item">
                    <a class="navi-link"  (click)="htmlFontSizeSet(22)">
                        <span class="navi-text">
                            Large
                        </span>
                    </a>
                </li>
            </ul>
    </div>
</div>
